import CrudRepository from './CrudRepository'
import Repository from './Repository'
export default class BundlesCategoriesRepository extends CrudRepository {
  constructor () {
    super('/core/api/bundleCategories/web')
  }

  async get () {
    // const data = await Repository.get(`${this.resource}`)
    const data = await Repository.get(`${this.resource}`)
    return data.data
  }
}
